import React from "react";

const STEPS = [
	{
		key: "ai",
		label: "AI View",
		subtitle: "Browser capture with JavaScript disabled",
		completeClass: "dual-lens__pipeline-step--complete-ai",
		matchers: [/^ai view/i, /javascript disabled/i, /no.?js/i, /playwright_no_js/i],
	},
	{
		key: "idle",
		label: "Without interaction",
		subtitle: "Browser load at network idle",
		completeClass: "dual-lens__pipeline-step--complete-idle",
		matchers: [
			/^without interaction/i,
			/network idle/i,
			/playwright_idle/i,
			/\bidle\b/i,
		],
	},
	{
		key: "scroll",
		label: "With interaction (scroll)",
		subtitle: "After scrolling the full page",
		completeClass: "dual-lens__pipeline-step--complete-scroll",
		matchers: [/with interaction/i, /\bscroll/i, /playwright_scroll/i],
	},
];

export function currentStepIndexFromStatusLabel(statusLabel) {
	if (!statusLabel) return 0;

	const label = statusLabel.trim();
	if (/loading comparison/i.test(label)) return STEPS.length;

	for (let i = STEPS.length - 1; i >= 0; i--) {
		if (STEPS[i].matchers.some((matcher) => matcher.test(label))) {
			return i;
		}
	}

	if (/^queued$/i.test(label) || /^processing$/i.test(label) || /^preparing/i.test(label)) {
		return 0;
	}

	return 0;
}

export default function DualLensPipelineSteps({ statusLabel, progress=0 }) {
	const currentIdx = currentStepIndexFromStatusLabel(statusLabel);
	const allComplete = currentIdx >= STEPS.length;

	return (
		<div className="dual-lens__pipeline">
			{progress != null && progress > 0 &&(
				<div className="dual-lens__progress mb-3">
					<div className="dual-lens__progress-bar">
						<div
							className="dual-lens__progress-fill"
							style={{ width: `${progress}%` }}
						/>
					</div>
					<p className="dual-lens__progress-label text-muted small mb-0">{progress}%</p>
				</div>
			)}
			<ol className="dual-lens__pipeline-steps list-unstyled mb-0">
				{STEPS.map((step, index) => {
					const isComplete = allComplete || currentIdx > index;
					const isCurrent = !allComplete && currentIdx === index;

					let stepClass = "dual-lens__pipeline-step dual-lens__pipeline-step--pending";
					if (isComplete) {
						stepClass = `dual-lens__pipeline-step ${step.completeClass}`;
					} else if (isCurrent) {
						stepClass = "dual-lens__pipeline-step dual-lens__pipeline-step--current";
					}

					let iconClass = "dual-lens__pipeline-step-icon dual-lens__pipeline-step-icon--pending";
					let icon = "far fa-circle";
					if (isComplete) {
						iconClass = "dual-lens__pipeline-step-icon dual-lens__pipeline-step-icon--complete";
						icon = "fas fa-check";
					} else if (isCurrent) {
						iconClass = "dual-lens__pipeline-step-icon dual-lens__pipeline-step-icon--current";
						icon = "fas fa-spinner fa-spin";
					}

					return (
						<li key={step.key} className={stepClass}>
							<span className={iconClass} aria-hidden="true">
								<i className={icon} />
							</span>
							<div className="dual-lens__pipeline-step-text">
								<p className="dual-lens__pipeline-step-title mb-0">{step.label}</p>
								<p className="dual-lens__pipeline-step-subtitle mb-0">{step.subtitle}</p>
							</div>
						</li>
					);
				})}
			</ol>
		</div>
	);
}
